import type { SyncPhase } from '@viva/core';
import type { SyncTask } from '../state/catalog-context';
import { t, useLanguage } from '../i18n';
import type { MessageKey } from '../i18n/en';

const PHASES: Record<SyncPhase, MessageKey> = {
  connecting: 'sync.connecting',
  downloading: 'sync.downloading',
  live: 'sync.live',
  movie: 'sync.movie',
  series: 'sync.series',
  saving: 'sync.saving',
};

function megabytes(bytes: number): string {
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

/** Progress of the running sync, with cancel. */
export function SyncStatus({ task }: { task: SyncTask }) {
  useLanguage();
  const progress = task.progress;
  const fraction = progress?.totalBytes ? Math.min(1, progress.bytes / progress.totalBytes) : null;
  const parts = progress
    ? [
        t(PHASES[progress.phase]),
        progress.items > 0 ? t('sync.items', { count: progress.items.toLocaleString() }) : null,
        progress.bytes > 0 ? (progress.totalBytes ? t('sync.of', { done: megabytes(progress.bytes), total: megabytes(progress.totalBytes) }) : megabytes(progress.bytes)) : null,
      ]
    : [t('sync.starting')];
  return (
    <div className="sync-status" role="status" aria-live="polite">
      <div className="sync-status__text">
        <strong>{task.label}</strong>
        <span className="muted">{parts.filter(Boolean).join(' · ')}</span>
      </div>
      <div className="progress" data-indeterminate={fraction === null}>
        <div className="progress__bar" style={fraction === null ? undefined : { width: `${fraction * 100}%` }} />
      </div>
      <button type="button" className="button ghost" onClick={task.cancel}>
        {t('common.cancel')}
      </button>
    </div>
  );
}
